import AdminTeamBuilder from './AdminTeamBuilder';

export default AdminTeamBuilder;
